import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import {
  addNewTaskPriority,
  addNewTaskPrioritySuccess,
  addNewTaskStatus,
  addNewTaskStatusSuccess,
  addNewTaskType,
  addNewTaskTypeSuccess,
  deleteTaskPriority,
  deleteTaskPrioritySuccess,
  deleteTaskStatus,
  deleteTaskStatusSuccess,
  deleteTaskType,
  deleteTaskTypeSuccess,
  getTaskPriorityList,
  getTaskStatusListCrmIT,
  getTaskTypeList,
  updateTaskPriority,
  updateTaskPrioritySuccess,
  updateTaskStatus,
  updateTaskStatusSuccess,
  updateTaskType,
  updateTaskTypeSuccess,
} from "../../../../store/tasksCrmIT/action";
import {
  createVehicleStatus,
  createVehicleStatusSuccess,
  createVehicleType,
  createVehicleTypeSuccess,
  deleteVehicleStatus,
  deleteVehicleStatusSuccess,
  deleteVehicleType,
  deleteVehicleTypeSuccess,
  listVehicleStatus,
  listVehicleType,
  updateVehicleStatus,
  updateVehicleStatusSuccess,
  updateVehicleType,
  updateVehicleTypeSuccess,
} from "../../../../store/vehicle/action";
export default function VehicleSettings() {
  const dispatch = useDispatch();

  // const { taskPriorityList, taskTypeList, tasksCrmITStatusListApi } =
  //   useSelector((state) => ({
  //     taskPriorityList: state.TasksCrmIt.taskPriorityList?.taskpriority_list,
  //     taskTypeList: state.TasksCrmIt.taskTypeList?.tasktype_list,
  //     tasksCrmITStatusListApi:
  //       state.TasksCrmIt.taskStatusListCrmIT?.taskstatus_list,
  //   }));

  const { vehicleStatusListAPI, vehicleTypeListAPI } = useSelector((state) => ({
    vehicleStatusListAPI: state.Vehicle.vehicleStatusList?.vehiclestatus_list,
    vehicleTypeListAPI: state.Vehicle.vehicleTypeList?.vehicletype_list,
  }));

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [statusFlag, setStatusFlag] = useState(false);
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    FlagActive: "0",
  });

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      // Task Status create
      dispatch(createVehicleStatus([createStatus]));
    }
    if (activeTab === "2") {
      // Task Type create
      dispatch(createVehicleType([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = vehicleStatusListAPI?.sort((a, b) => b.Id - a.Id);
      setStatusFlag(true);
    }
    if (activeTab === "2") {
      data = vehicleTypeListAPI?.sort((a, b) => b.Id - a.Id);
      setStatusFlag(false);
    }

    setStatusList(data);
  }, [vehicleStatusListAPI, vehicleTypeListAPI, activeTab]);

  useEffect(() => {
    dispatch(listVehicleStatus());
    dispatch(listVehicleType());
  }, []);

  const Tabs = [
    {
      id: "1",
      name: "Status",
    },
    {
      id: "2",
      name: "Types",
    },
  ];
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //  Task Status delete

      dispatch(deleteVehicleStatus([deleteStatus]));
    }
    if (activeTab === "2") {
      // Task Type delete
      dispatch(deleteVehicleType([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      FlagActive: updateItemStatus?.FlagActive,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        // Task Status update

        dispatch(updateVehicleStatus([updateNewStatus]));
      }
      if (activeTab === "2") {
        // Task Type update
        dispatch(updateVehicleType([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  const {
    vehicleStatusCreateSuccessAPI,
    vehicleStatusUpdateSuccessAPI,
    vehicleStatusDeleteSuccessAPI,
  } = useSelector((state) => ({
    vehicleStatusCreateSuccessAPI: state.Vehicle.vehicleStatusCreate,
    vehicleStatusUpdateSuccessAPI: state.Vehicle.vehicleStatusUpdate,
    vehicleStatusDeleteSuccessAPI: state.Vehicle.vehicleStatusDelete,
  }));

  // Add New Task Status response
  useEffect(() => {
    if (isEmpty(vehicleStatusCreateSuccessAPI)) return;
    if (vehicleStatusCreateSuccessAPI?.status === 200) {
      toast.success(vehicleStatusCreateSuccessAPI?.message);
      dispatch(listVehicleStatus());
    } else {
      toast.error(vehicleStatusCreateSuccessAPI?.message);
    }
    dispatch(createVehicleStatusSuccess([]));
  }, [vehicleStatusCreateSuccessAPI]);
  // Update Task Status response
  useEffect(() => {
    if (isEmpty(vehicleStatusUpdateSuccessAPI)) return;
    if (vehicleStatusUpdateSuccessAPI?.status === 200) {
      toast.success(vehicleStatusUpdateSuccessAPI?.message);
      dispatch(listVehicleStatus());
    } else {
      toast.error(vehicleStatusUpdateSuccessAPI?.message);
    }
    dispatch(updateVehicleStatusSuccess([]));
  }, [vehicleStatusUpdateSuccessAPI]);
  // Delete Task Status response
  useEffect(() => {
    if (isEmpty(vehicleStatusDeleteSuccessAPI)) return;
    if (vehicleStatusDeleteSuccessAPI?.status === 200) {
      toast.success(vehicleStatusDeleteSuccessAPI?.message);
      dispatch(listVehicleStatus());
      setDeleteModal(false);
    } else {
      toast.error(vehicleStatusDeleteSuccessAPI?.message);
    }
    dispatch(deleteVehicleStatusSuccess([]));
  }, [vehicleStatusDeleteSuccessAPI]);

  const {
    vehicleTypeCreateSuccessAPI,
    vehicleTypeUpdateSuccessAPI,
    vehicleTypeDeleteSuccessAPI,
  } = useSelector((state) => ({
    vehicleTypeCreateSuccessAPI: state.Vehicle.vehicleTypeCreate,
    vehicleTypeUpdateSuccessAPI: state.Vehicle.vehicleTypeUpdate,
    vehicleTypeDeleteSuccessAPI: state.Vehicle.vehicleTypeDelete,
  }));

  // Add New Task Type response
  useEffect(() => {
    if (isEmpty(vehicleTypeCreateSuccessAPI)) return;
    if (vehicleTypeCreateSuccessAPI?.status === 200) {
      toast.success(vehicleTypeCreateSuccessAPI?.message);

      dispatch(listVehicleType());
    } else {
      toast.error(vehicleTypeCreateSuccessAPI?.message);
    }
    dispatch(createVehicleTypeSuccess([]));
  }, [vehicleTypeCreateSuccessAPI]);
  // Update Task Type response
  useEffect(() => {
    if (isEmpty(vehicleTypeUpdateSuccessAPI)) return;
    if (vehicleTypeUpdateSuccessAPI?.status === 200) {
      toast.success(vehicleTypeUpdateSuccessAPI?.message);

      dispatch(listVehicleType());
    } else {
      toast.error(vehicleTypeUpdateSuccessAPI?.message);
    }
    dispatch(updateVehicleTypeSuccess([]));
  }, [vehicleTypeUpdateSuccessAPI]);
  // Delete Task Type response
  useEffect(() => {
    if (isEmpty(vehicleTypeDeleteSuccessAPI)) return;
    if (vehicleTypeDeleteSuccessAPI?.status === 200) {
      toast.success(vehicleTypeDeleteSuccessAPI?.message);
      dispatch(listVehicleType());
      setDeleteModal(false);
    } else {
      toast.error(vehicleTypeDeleteSuccessAPI?.message);
    }
    dispatch(deleteVehicleTypeSuccess([]));
  }, [vehicleTypeDeleteSuccessAPI]);

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteStatus}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
      />
      <SettingsPanel
        title="Vehicle Settings"
        description="Statuses and types for vehicles."
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
          statusFlag={statusFlag}
        />
      </SettingsPanel>
    </>
  );
}
